document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.bizzo-product-form');
  forms.forEach((form) => {
    const selects = form.querySelectorAll('select[name^="options"]');
    if (!selects.length) return;
    selects.forEach((select) => {
      select.addEventListener('change', () => {
        // Shopify will still validate the submitted variant server-side.
        // Variant-selection enhancement can be added after products are imported.
      });
    });
  });
});

// Fix BIZZO (Prioridad 3, auditoría nocturna 2026-09-18): navegación móvil.
// .bizzo-nav se ocultaba por completo en ≤900px (assets/bizzo.css) sin
// ningún mecanismo de reemplazo, dejando Inicio/Catálogo y el resto del
// menú inaccesibles en todo viewport móvil, en todas las páginas (Home,
// Catálogo, ficha de producto y carrito, ya que bizzo-header.liquid es
// compartido). Este bloque solo abre/cierra el mismo <nav> ya existente
// (mismos enlaces) como panel desplegable accesible; no agrega ni cambia
// ningún enlace ni el diseño del header.
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.bizzo-header');
  const toggle = header && header.querySelector('[data-bizzo-nav-toggle]');
  const nav = header && header.querySelector('.bizzo-nav');
  if (!header || !toggle || !nav) return;

  function closeNav() {
    header.classList.remove('is-nav-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function openNav() {
    header.classList.add('is-nav-open');
    toggle.setAttribute('aria-expanded', 'true');
  }

  toggle.addEventListener('click', (event) => {
    event.stopPropagation();
    if (header.classList.contains('is-nav-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  document.addEventListener('click', (event) => {
    if (header.classList.contains('is-nav-open') && !header.contains(event.target)) {
      closeNav();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeNav();
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) closeNav();
  });
});

// BIZZO: CTA visible de pago contra entrega conectado al botón nativo de Releasit.
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const trigger = target && target.closest('[data-bizzo-cod-trigger]');
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  const form = trigger.closest('form');
  const openReleasit = () => {
    const nativeButton =
      (form && form.querySelector('#rsi_buy_now_button')) ||
      document.querySelector('#rsi_buy_now_button');

    if (!nativeButton || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true') return false;
    nativeButton.click();
    return true;
  };

  if (openReleasit()) return;

  let attempts = 0;
  const waitForReleasit = window.setInterval(() => {
    attempts += 1;
    if (openReleasit() || attempts >= 40) {
      window.clearInterval(waitForReleasit);
    }
  }, 150);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shopify-payment-button__button').forEach((button) => {
    button.setAttribute('aria-label', 'Paga ahora online');
  });
});
